module.exports = __webpack_public_path__ + "img/MG-HIW.32853d75.png";